(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-grid-ottantanove"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cats89__seg-btn');
    if (!btn) return;

    var card = btn.closest('[data-cats89-card]');
    if (!card) return;

    var href = btn.dataset.href;
    var name = btn.dataset.name;
    var gender = btn.dataset.gender;

    var seg = btn.closest('.cats89__seg');
    seg.querySelectorAll('.cats89__seg-btn').forEach(function (b) {
      b.classList.remove('is-on', 'is-red');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-on');
    if (gender === 'donna') btn.classList.add('is-red');
    btn.setAttribute('aria-pressed', 'true');

    var goLink = card.querySelector('.cats89__go');
    var nameLink = card.querySelector('.cats89__name a');
    if (goLink) goLink.href = href;
    if (nameLink) {
      nameLink.href = href;
      nameLink.textContent = name;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-ottantanove"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-gift89-section]').forEach(function (sec) {
    var amounts = sec.querySelector('[data-gift89-amounts]');
    var addBtn = sec.querySelector('[data-gift89-addbtn]');
    var btnPrice = sec.querySelector('[data-gift89-btnprice]');
    var cardAmt = sec.querySelector('[data-gift89-cardamt]');

    if (!amounts || !addBtn) return;

    amounts.addEventListener('click', function (e) {
      var chip = e.target.closest('.gift89__chip');
      if (!chip || chip.disabled) return;
      amounts.querySelectorAll('.gift89__chip').forEach(function (c) {
        c.classList.remove('is-on');
        c.setAttribute('aria-pressed', 'false');
      });
      chip.classList.add('is-on');
      chip.setAttribute('aria-pressed', 'true');
      addBtn.dataset.variantId = chip.dataset.variantId;
      if (btnPrice) btnPrice.textContent = chip.dataset.price;
      if (cardAmt) cardAmt.textContent = chip.dataset.priceFull;
      addBtn.classList.remove('is-success', 'is-loading');
      addBtn.disabled = false;
    });

    addBtn.addEventListener('click', function () {
      var variantId = parseInt(addBtn.dataset.variantId, 10);
      if (!variantId || addBtn.disabled) return;
      addBtn.classList.add('is-loading');
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          addBtn.classList.remove('is-loading');
          addBtn.classList.add('is-success');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            addBtn.classList.remove('is-success');
            addBtn.disabled = false;
          }, 2500);
        })
        .catch(function () {
          addBtn.classList.remove('is-loading');
          addBtn.disabled = false;
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-ottantanove"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-slide89-section]').forEach(function (sec) {
    var track = sec.querySelector('[data-slide89-track]');
    if (!track) return;

    var slides = track.querySelectorAll('.slide89__slide');
    var dots = sec.querySelectorAll('[data-slide89-dot]');
    var prevBtn = sec.querySelector('[data-slide89-prev]');
    var nextBtn = sec.querySelector('[data-slide89-next]');
    var total = slides.length;
    var current = 0;
    var autoplay = sec.dataset.autoplay === 'true';
    var speed = (parseInt(sec.dataset.autoplaySpeed, 10) || 5) * 1000;
    var timer = null;
    var touchStartX = 0;

    if (total <= 1) return;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      current = ((index % total) + total) % total;
      slides[current].classList.add('is-active');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    function startTimer() {
      if (!autoplay) return;
      timer = setInterval(function () { goTo(current + 1); }, speed);
    }

    function resetTimer() {
      clearInterval(timer);
      startTimer();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goTo(current - 1); resetTimer(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goTo(current + 1); resetTimer(); });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.slide89Dot, 10));
        resetTimer();
      });
    });

    sec.addEventListener('mouseenter', function () { clearInterval(timer); });
    sec.addEventListener('mouseleave', startTimer);

    sec.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });

    sec.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        goTo(diff > 0 ? current + 1 : current - 1);
        resetTimer();
      }
    }, { passive: true });

    startTimer();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
